import {useState} from "react";

let ws: WebSocket | null = null;
const pendingAudios: Array<Array<number>> = [];
let isAudioPlaying = false;

const useTTS = () => {
    const playAudio = (audio: any, onEnd = () => {}, sampleRate = 16000) => {
        console.log('audio pending length', pendingAudios.length)
        const audioContext = new AudioContext();
        const audioBuffer = audioContext.createBuffer(1, audio.length, sampleRate);
        audioBuffer.getChannelData(0).set(audio);
        const audioSource = audioContext.createBufferSource();
        audioSource.buffer = audioBuffer;
        audioSource.onended = onEnd;
        audioSource.connect(audioContext.destination);
        audioSource.start();
    }

    const pushPendingAudio = (audio: number[]) => {
        pendingAudios.push(audio);
    }

    const shiftPendingAudio = () => {
        if (pendingAudios.length === 0) {
            return null;
        }
        return pendingAudios.shift();
    }

    const playPendingAudio = () => {
        const audio = shiftPendingAudio();
        if (audio) {
            console.log('playing audio')
            isAudioPlaying = true;
            playAudio(audio, () => {
                console.log('audio ended')
                playPendingAudio();
            });
        } else {
            isAudioPlaying = false;
        }
    }

    const synthesizeStreaming = async (text: string, autoPlayAudio: boolean = true, onAudio = (audio: []) => {}) => {
        console.log('synthesize', text);
        // @ts-ignore
        // if(cache[text]) {
        //     console.log('cache hit')
        //     // @ts-ignore
        //     return cache[text];
        // }


        const send = (ws: WebSocket, stream: boolean = false) => {
            if (stream) {
                text.split(' ').forEach((word) => {
                    setTimeout( () => {
                        ws.send(JSON.stringify({
                            'text': word
                        }));
                    }, 1000)
                });
            } else {
                ws.send(JSON.stringify({
                    'text': text
                }));
            }

        }
        if (ws == null || (ws.readyState !== WebSocket.OPEN && ws.readyState !== WebSocket.CONNECTING)) {
            const _ws = new WebSocket(`ws://humbly-vast-gnat.cr8dl.ai/v1/synthesize/streaming`);
            ws = _ws;
            console.log('new websocket')
            _ws.addEventListener('open', function (event) {
                console.log('websocket open')
                if (_ws !== null) {
                    send(_ws);
                }
            });

            _ws.addEventListener('message', function (event) {
                const data = JSON.parse(event.data);
                let audio = data.audio;
                if (typeof audio[0] === 'number') {
                    audio = data.audio;
                } else {
                    audio = data.audio[0];
                }
                onAudio(audio);
                console.log('audio', audio)
                if (autoPlayAudio) {
                    pushPendingAudio(audio);
                    console.log('after push - pending audio length', pendingAudios.length)
                    if (!isAudioPlaying) {
                        isAudioPlaying = true;
                        playPendingAudio();
                    }
                }

            });

            _ws.addEventListener('error', function (event) {
                console.log('websocket error', event)
            });

        } else if (ws.readyState === WebSocket.OPEN) {
            console.log('websocket is already open')
            send(ws);
        } else if (ws.readyState === WebSocket.CONNECTING) {
            console.error('websocket is connecting.')
        } else {
            console.error('Problem in websocket connection')
        }
        return ws;
    };

    const reset = () => {
        if (ws) {
            ws.send(JSON.stringify({
                'session_complete': true
            }));
        }
        pendingAudios.length = 0;
    }

    return {
        synthesizeStreaming,
        reset
    }
}

export default useTTS;
